import { useState, useEffect } from 'react'
import { useInstallPrompt } from '@/hooks/pwa/useInstallPrompt'
import { CloseIcon } from '@/icons'

const DISMISS_KEY = 'treasurelog-install-dismissed'

export default function InstallBanner() {
  const { canInstall, promptInstall, manualInstallType, hasNativePrompt } = useInstallPrompt()
  const [dismissed, setDismissed] = useState(true)

  useEffect(() => {
    const wasDismissed = localStorage.getItem(DISMISS_KEY)
    setDismissed(!!wasDismissed)
  }, [])

  const handleDismiss = () => {
    setDismissed(true)
    localStorage.setItem(DISMISS_KEY, '1')
  }

  if (!canInstall || dismissed) return null

  return (
    <div className="md:hidden bg-blue-900 text-white px-4 py-2 flex items-center justify-between gap-2">
      {hasNativePrompt ? (
        <>
          <span className="text-sm flex-1">Install TreasureLog for a better experience</span>
          <button
            onClick={promptInstall}
            className="bg-blue-600 text-white px-3 py-1 rounded text-sm font-medium hover:bg-blue-700 transition-colors whitespace-nowrap"
          >
            Install
          </button>
        </>
      ) : (
        <span className="text-sm flex-1">
          {manualInstallType === 'ios' && <>Install TreasureLog: tap ⬆ then &quot;Add to Home Screen&quot;</>}
          {manualInstallType === 'firefox' && <>Install TreasureLog: tap ⋮ menu then &quot;Install&quot;</>}
        </span>
      )}

      <button onClick={handleDismiss} className="p-1 hover:bg-blue-800 rounded transition-colors" aria-label="Dismiss">
        <CloseIcon className="w-4 h-4" />
      </button>
    </div>
  )
}
